import React from 'react';
import FeaturedEvents from './FeaturedEvents';
import SEOHead from '../../seo/SEOHead';
import { getSEOData } from '../../seo/seoConfig';
import { Calendar } from 'lucide-react';
import Footer from '../../components/footer/Footer';
import './Events.css';

export default function Events() {
  const seoData = getSEOData('/events');

  return (
    <div className="cb-events-wrapper">
      <SEOHead {...seoData} />

      <div className="cb-events-ambient-grid" />
      <div className="cb-events-ambient-glow" />

      <section className="cb-events-hero-section">
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '7px 18px',
            borderRadius: '9999px',
            backgroundColor: 'rgba(79, 25, 133, 0.08)',
            border: '1.5px solid rgba(79, 25, 133, 0.16)',
            fontSize: '12px',
            fontFamily: "'JetBrains Mono', monospace",
            fontWeight: 800,
            color: '#4F1985',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            marginBottom: '18px'
          }}
        >
          <Calendar size={13} color="#4F1985" />
          <span>ChemBio AI Research Ecosystem</span>
        </div>

        <h1
          style={{
            fontFamily: "'Space Grotesk', -apple-system, sans-serif",
            fontSize: 'clamp(2.5rem, 5.5vw, 4.4rem)',
            fontWeight: 900,
            letterSpacing: '-0.04em',
            color: '#0f172a',
            margin: '0 0 16px',
            lineHeight: 1.05
          }}
        >
          Events &amp;{' '}
          <span
            style={{
              background: 'linear-gradient(135deg, #170d2b 0%, #4F1985 45%, #9047ff 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              display: 'inline-block'
            }}
          >
            Hackathons
          </span>
        </h1>

        <p
          style={{
            fontSize: 'clamp(1rem, 1.4vw, 1.15rem)',
            color: '#475569',
            lineHeight: 1.7,
            maxWidth: '820px',
            margin: '0 auto 40px',
            fontWeight: 450
          }}
        >
          Explore active scientific hackathons, research symposiums, and hands-on discovery sprints designed for researchers, computational chemists, bioinformaticians, and AI innovators.
        </p>
      </section>

      <div className="cb-events-content">
        <FeaturedEvents />
      </div>

      <Footer />
    </div>
  );
}
